import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { queryClient } from '@/lib/react-query/queryClient';
import { coordinationEndpoints } from '@/modules/coordination/constants';
import { coordinationQueryKeys } from '@/modules/coordination/queries/queryKeys';
import type { UpsertMeetingCandidateMetadataRequestApi } from '@/modules/coordination/types';

interface UpsertMeetingCandidateEmailVariables {
  meetingId: string;
  body: UpsertMeetingCandidateMetadataRequestApi;
}

export const useUpsertMeetingCandidateEmailMutation = () => {
  return useMutation({
    mutationFn: async ({
      meetingId,
      body,
    }: UpsertMeetingCandidateEmailVariables) => {
      const { data } = await fetchClient.PUT(
        coordinationEndpoints.meetingCandidateMetadata,
        {
          params: { path: { meetingId } },
          body,
        },
      );

      return data;
    },
    onSuccess: (_, variables) => {
      return queryClient.invalidateQueries({
        queryKey: coordinationQueryKeys.meeting(variables.meetingId),
      });
    },
  });
};
